import { render } from "./TermsAndConditionsView.vue?vue&type=template&id=654a8718&scoped=true"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js"

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=654a8718&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654a8718"]])

export default __exports__